import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {message } from '../_constants';
import Header from './Inc/Layout/Header.js';
import Footer from './Inc/Layout/Footer.js';
import GreensearchImage from '../image/green-search.png';
import CitySuggestion from './Layout/CitySuggestion';
import searchImage from '../image/search.png';
//import CitySuggestion from './Layout/CitySuggestion';
//import "./loader.css";
import loadingLocation from "./loading.gif"
let wait=false;
class RedirectToCity extends Component {
 
    constructor(props) {
        super(props);
        this.state = {
            city:'',
            locationUser:""
        }
        
        //this.locationDedect=this.locationDedect.bind(this)

    }

    async componentDidMount () {
        var cityLocation = await this.props.auth.getGeoInfo();
       // console.log("cityLocation", cityLocation);
        if(cityLocation){
            wait=true;
        }
        this.setState({
            city:cityLocation,
            //coordinate:coordinate
        });
        // this.locationDedect();
    }


/*    locationDedect (){
        let _this = this;
        
        if(sessionStorage.getItem("defaultCity")===null){
            let coordinate=[];
                //alert("hello");
            navigator.geolocation.getCurrentPosition(function(position) {
                console.log("position", position);
                var lat = position.coords.latitude;
                var lng = position.coords.longitude;
                
                coordinate.push(lat);
                coordinate.push(lng);
                
                if(position.coords.latitude && position.coords.longitude){
                    
                    let locUrl = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + position.coords.latitude + ',' + position.coords.longitude + '&key=AIzaSyBnzPuZBr2iOBAtzbL5eYChxGxJw9Za-ak';
                    fetch(locUrl)
                        .then((response) => response.json())
                        .then((responseJson) => {

                            //alert(_this.state.city);
                            
                            var fullAddress = responseJson.results[0].address_components;
                            for (var i in fullAddress) {

                                if (fullAddress[i].types.indexOf("locality") >= 0) {
                                    let str = fullAddress[i].long_name;
                                    sessionStorage.setItem("changeCity", false)
                                    sessionStorage.setItem("defaultCity",str);
                                    sessionStorage.setItem("coordinate", JSON.stringify(coordinate));

                                     wait = true;
                                    _this.setState({
                                        city:fullAddress[i].long_name,
                                        coordinate:coordinate
                                    });
                                }
                            }

                            //alert(_this.state.city);
                        }).catch(error => console.error('Error', error));
                }

            },function(error) {
                    wait = true; 
                    _this.setState({
                       locationUser:false
                    })
                if (error.code == error.PERMISSION_DENIED){
                    console.log("error", error);
                }
            },{  enableHighAccuracy: true }
           );         
        }else{
            wait=true;
            _this.setState({
              city:sessionStorage.getItem("defaultCity")
            });
        } 
    }*/




    handleChangeAddress = () => {
        //alert()
    }


    findData = (searchBY, e) => {
        const { city, fieldSelct } = this.state
        let reqObj = {}
        //console.log("searchBY", searchBY,e);
        if (fieldSelct.length > 0) {
            reqObj["fieldSelct"] = fieldSelct;
            if (city) {
                reqObj["search"] = city;
            } else {
                reqObj["search"] = "all";
            }

            reqObj["userType"] = "all"
            if (searchBY === "recruiter") {
                reqObj["userType"] = "recruiter";
            }
            if (searchBY === "company") {
                reqObj["userType"] = "company";
            }
            this.props.history.push({
                pathname: this.props.auth.cityUrlFunction("/search-result"),
                state: { "reqObj": reqObj }
            });
        } else {
            this.props.auth.error(message.fieldSelect);
        }

    }


    render() {

            if(wait){
                //sessionStorage.setItem("defaultCity",this.state.city)
                if(localStorage.getItem("defaultCity")){
                    let cityName=localStorage.getItem("defaultCity").replace(/\s+/g,'');
                    console.log("cityName", cityName);
                    this.props.history.push({
                        pathname: "/"+cityName,
                    });
                }else{
                    this.props.history.push({
                        pathname: "/home",
                    });
                  }
            }
        return (
            <div>
                <div className="search-pageForLoading">
                   <div className="wrap">
                      <div className="loading">
                            <img src={loadingLocation} alt="Location"/>
                      </div>
                  </div> 
                </div>

            <div className="overlay-overForLoading"></div>
            <div className="home-wrapper">
               <div className="bg-right">
                  <Header props={ this.props }/>
                      <div className="body-wrapper">                  
                        <div className="container" >
                           <div className="main-content">
                              <div className="row ">
                                <div className="col-md-8">
                                  <h2 className="top-title">A Right Connection can change your life</h2>
                                  <h3 className="top-sub-title">We help you connect with Recruiters</h3>
                                </div>
                                <div className="col-md-8"> 
                                  <div className="">
                                    <div className="custom-style spc-labels">
                                        <input type="checkbox" className="new-chkbox" name="fields" id="Recruiting"  value="Recruiting"  />
                                        <label htmlFor="Recruiting">Recruiting</label>
                                    </div> 
                                    <div className="custom-style spc-labels">
                                        <input type="checkbox" className="new-chkbox" name="fields" id="Part Time"  value="Part Time"  />
                                        <label htmlFor="Part Time">Part Time</label>
                                    </div>
                                    <div className="custom-style spc-labels">
                                        <input type="checkbox" className="new-chkbox" name="fields" id="Non Profit"  value="Non Profit"  />
                                        <label htmlFor="Non Profit">Non Profit</label>
                                    </div> 
                                    <div className="custom-style spc-labels">
                                        <input type="checkbox" className="new-chkbox" name="fields" id="Management"  value="Management"  />
                                        <label htmlFor="Management">Management</label>
                                    </div>
                                    <div className="custom-style spc-labels">
                                        <input type="checkbox" className="new-chkbox" name="fields" id="It"  value="It"  />
                                        <label htmlFor="It">It</label>
                                    </div>
                                    <div className="custom-style spc-labels">
                                        <input type="checkbox" className="new-chkbox" name="fields" id="Human Resoures"  value="Human Resoures"  />
                                        <label htmlFor="Human Resoures">Human Resoures</label>
                                    </div>
                                    <div className="custom-style spc-labels">
                                        <input type="checkbox" className="new-chkbox" name="fields" id="Hospitality"  value="Hospitality"  />
                                        <label htmlFor="Hospitality">Hospitality</label>
                                    </div>
                                    <div className="custom-style spc-labels">
                                        <input type="checkbox" className="new-chkbox" name="fields" id="Banking"  value="Banking"  />
                                        <label htmlFor="Banking">Banking</label>
                                    </div>
                                    <div className="custom-style spc-labels">
                                        <input type="checkbox" className="new-chkbox" name="fields" id="Accounting"  value="Accounting"  />
                                        <label htmlFor="Accounting">Accounting</label>
                                    </div>

                                   </div>
                                </div>     
                                <input id="searchTextField" />
                                  <div className="col-md-12 spc-mob">
                                    <div className="row">
                                      <div className="col-md-8 col-lg-5">
                                        <button className="btn1 rec-btn" onClick={this.findData.bind(this,"recruiter")}> Find A Recruiter 
                                         <img src={searchImage} alt="Location" />
                                        </button> 
                                      
                                        <button className="btn1 camp-btn" onClick={this.findData.bind(this,"company")}> Find A Company
                                           <img src={GreensearchImage} alt="Location" />
                                        </button> 
                                      </div>
                                      <div className="col-md-7 col-lg-4">
                                        <div className="location-box">
                                          {/*<img className="locate-image" src={locateImage}/>*/}
                                            <CitySuggestion onChange={this.handleChangeAddress.bind(this)} props={ this.props } /> 
                                          {/*<a><input type="text" className="fnew-control" placeholder="Search Location" onChange={this.changeCity} value={this.state.city} /><a onClick={this.findData.bind(this,"city")}>*/}
                                         {/* <img className="input-image" src={inputSearchImage}/></a>*/}
                                        </div>
                                      </div>
                                    </div> 
                                  </div> 
                                </div>
                             </div>
                          </div>
                        </div>
                      </div>                    
                <Footer/>
            </div>
            </div>
        );
    }
}

export default withRouter(RedirectToCity);


// WEBPACK FOOTER //
// ./src/components/RedirectToCity.js